import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import SultanKhanPathanImage from '../../assets/images/profiles/team/sultankhan-pathan.jpeg'
import ShashwatPalImage from '../../assets/images/profiles/team/shashwant-pal.jpeg'
import SufiyanShaikhImage from '../../assets/images/profiles/team/sufiyan-shaikh.jpeg'
import ArbajAnsariImage from '../../assets/images/profiles/team/arbaj-ansari.jpg'
import TahaseenShaikhImage from '../../assets/images/profiles/team/tahaseen-shah.jpeg'
import ZainabBadshahImage from '../../assets/images/profiles/team/zainab-badshah.jpeg'

// Sample faculty data
const facultyData = [
    { name: "Tahseen Shah", position: "Senior Software Engineer", company: "Iauro Systems", image: TahaseenShaikhImage },
    { name: "Shashwat Pal", position: "Software Engineer", company: "HTS", image: ShashwatPalImage },
    { name: "Zainab Badshah", position: "Cloud Engineer", company: "Infosys", image: ZainabBadshahImage },
    { name: "Arbaj Ansari", position: "Senior Software Developer", company: "HTS", image: ArbajAnsariImage },
    { name: "SultanKhan Patan", position: "Software Engineer", company: "Zerox Cloud", image: SultanKhanPathanImage },
    { name: "Sufiyan Shaikh", position: "Software Engineer", company: "Pronttera", image: SufiyanShaikhImage }
];

const FacultyCarousel = () => {
    return (
        <div className=" bg-[#FAEBD7]">
            <section className="relative section">
                {/* Section Title */}
                <div className="md:mb-12 mb-6">
                    <p className="text-xs uppercase font-semibold text-gray-500">Meet our esteemed faculty</p>
                    <h2 className="text-2xl font-medium text-gray-800">Learn from the Masters</h2>
                </div>

                {/* Navigation Buttons */}
                <div className="absolute top-1/2 left-0 z-10 mt-4 -translate-y-1/2">
                    <button className="swiper-button-prev  p-3 rounded-full ">
                        <FaChevronLeft className="text-lg text-gray-700" />
                    </button>
                </div>

                <div className="absolute top-1/2 right-0 z-10 mt-4 -translate-y-1/2">
                    <button className="swiper-button-next  p-3 rounded-full ">
                        <FaChevronRight className="text-lg text-gray-700" />
                    </button>
                </div>


                {/* Swiper Carousel */}
                <Swiper
                    spaceBetween={16}
                    navigation={{
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    }}
                    modules={[Navigation]}
                    loop
                    breakpoints={{
                        320: { slidesPerView: 1 },  // Mobile View: 1 card
                        640: { slidesPerView: 2 },  // Tablet View: 2 cards
                        1024: { slidesPerView: 4 }  // Desktop View: 4 cards
                    }}
                    className="max-w-[70rem] mx-auto"
                >
                    {facultyData.map((faculty, index) => (
                        <SwiperSlide key={index}>
                            <div className="bg-white rounded-lg shadow-md overflow-hidden">
                                <img src={faculty.image} alt={faculty.name} className="w-full h-64 object-cover " />
                                <div className="mt-4 p-4">
                                    <h3 className="text-xl font-semibold">{faculty.name}</h3>
                                    <p className="text-gray-600">{faculty.position}</p>
                                    <p className="text-blue-600 font-medium">{faculty.company}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>
        </div>

    );
};

export default FacultyCarousel;
